(function () {
  function initUsp(wrap) {
    if (wrap.dataset.sstUspReady === 'true') return;
    var track = wrap.querySelector('[data-sst-usp-track]');
    var dotsWrap = wrap.querySelector('[data-sst-usp-dots]');
    if (!track || !dotsWrap) return;

    wrap.dataset.sstUspReady = 'true';

    var slides = Array.prototype.slice.call(track.children);
    if (slides.length < 2) return;

    var slideCount = slides.length;
    var currentIndex = 0;
    var scrollEndTimer = null;
    var resizeTimer = null;
    var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var mobileQuery = window.matchMedia('(max-width: 900px)');

    function prepareClone(slide, label) {
      var clone = slide.cloneNode(true);
      clone.setAttribute('data-sst-usp-clone', label);
      clone.setAttribute('aria-hidden', 'true');
      Array.prototype.slice.call(clone.attributes).forEach(function (attr) {
        if (attr.name.indexOf('data-shopify') === 0) clone.removeAttribute(attr.name);
      });
      clone.querySelectorAll('*').forEach(function (node) {
        Array.prototype.slice.call(node.attributes).forEach(function (attr) {
          if (attr.name.indexOf('data-shopify') === 0) node.removeAttribute(attr.name);
        });
      });
      clone.querySelectorAll('a, button, input, select, textarea, [tabindex]').forEach(function (node) {
        node.setAttribute('tabindex', '-1');
      });
      clone.querySelectorAll('[id]').forEach(function (node) {
        node.removeAttribute('id');
      });
      return clone;
    }

    track.insertBefore(prepareClone(slides[slideCount - 1], 'last'), slides[0]);
    track.appendChild(prepareClone(slides[0], 'first'));

    var dots = slides.map(function (_, i) {
      var dot = document.createElement('button');
      dot.type = 'button';
      dot.className = 'sst-usp__dot';
      dot.setAttribute('aria-label', 'Go to slide ' + (i + 1));
      dot.addEventListener('click', function () {
        stop();
        scrollToIndex(i, 'smooth');
        start();
      });
      dotsWrap.appendChild(dot);
      return dot;
    });

    function isSlider() {
      return mobileQuery.matches && track.scrollWidth > track.clientWidth + 1;
    }

    function visualIndex() {
      if (!track.clientWidth) return 0;
      return Math.round(track.scrollLeft / track.clientWidth);
    }

    function activeIndex() {
      var index = visualIndex() - 1;
      if (index < 0) return slideCount - 1;
      if (index >= slideCount) return 0;
      return index;
    }

    function setPosition(index, behavior, useEdgeClone) {
      if (!track.clientWidth) return;
      var boundedIndex = (index + slideCount) % slideCount;
      var targetVisualIndex = boundedIndex + 1;

      if (useEdgeClone && index < 0) {
        targetVisualIndex = 0;
      } else if (useEdgeClone && index >= slideCount) {
        targetVisualIndex = slideCount + 1;
      }

      currentIndex = boundedIndex;
      track.scrollTo({ left: targetVisualIndex * track.clientWidth, behavior: behavior || 'smooth' });
      updateDots(currentIndex);
    }

    function scrollToIndex(index, behavior) {
      setPosition(index, behavior, false);
    }

    function scrollToInfiniteIndex(index) {
      setPosition(index, 'smooth', true);
    }

    function settleInfiniteEdge() {
      if (!isSlider()) return;

      if (visualIndex() === 0) {
        setPosition(slideCount - 1, 'auto', false);
      } else if (visualIndex() === slideCount + 1) {
        setPosition(0, 'auto', false);
      } else {
        update();
      }
    }

    function updateDots(index) {
      dots.forEach(function (dot, i) { dot.classList.toggle('is-active', i === index); });
    }

    function update() {
      var index = activeIndex();
      currentIndex = index;
      updateDots(index);
    }

    track.addEventListener('scroll', function () {
      update();
      window.clearTimeout(scrollEndTimer);
      scrollEndTimer = window.setTimeout(settleInfiniteEdge, 120);
    });
    var timer = null;

    function advance() {
      if (!isSlider()) return;
      scrollToInfiniteIndex(currentIndex + 1);
    }

    function start() {
      if (timer || reduceMotion || !isSlider()) return;
      timer = window.setInterval(advance, 5000);
    }

    function stop() {
      window.clearInterval(timer);
      timer = null;
    }

    function syncPosition() {
      if (!isSlider()) {
        stop();
        updateDots(currentIndex);
        return;
      }
      scrollToIndex(currentIndex, 'auto');
      start();
    }

    wrap.addEventListener('pointerenter', stop);
    wrap.addEventListener('pointerleave', start);
    wrap.addEventListener('touchstart', stop, { passive: true });
    wrap.addEventListener('touchend', start, { passive: true });
    wrap.addEventListener('focusin', stop);
    wrap.addEventListener('focusout', start);
    window.addEventListener('resize', function () {
      window.clearTimeout(resizeTimer);
      resizeTimer = window.setTimeout(syncPosition, 120);
    }, { passive: true });
    if (mobileQuery.addEventListener) {
      mobileQuery.addEventListener('change', syncPosition);
    }
    window.requestAnimationFrame(syncPosition);
  }

  function initAll(root) {
    if (root.matches && root.matches('[data-sst-usp]')) initUsp(root);
    if (root.querySelectorAll) root.querySelectorAll('[data-sst-usp]').forEach(initUsp);
  }

  initAll(document);

  document.addEventListener('shopify:section:load', function (event) {
    initAll(event.target);
  });
})();
